export class BetlevelMenuEvents {
	public static readonly BET_VALUE_UPDATED: string = 'BetlevelMenuEvents::BET_VALUE_UPDATED';
	public static readonly BET_LEVEL_MENU_OPENED: string = 'BetlevelMenuEvents::BET_LEVEL_MENU_OPENED';
	public static readonly BET_LEVEL_MENU_CLOSED: string = 'BetlevelMenuEvents::BET_LEVEL_MENU_CLOSED';

	public static readonly BET_LEVEL_MENU_CANCELLED: string = 'BetlevelMenuEvents::BET_LEVEL_MENU_CANCELLED';
	public static readonly BET_LEVEL_MENU_SELECTED_BET_ACCEPTED: string = 'BetlevelMenuEvents::BET_LEVEL_MENU_OPTION_ACCEPTED';
}



// WEBPACK FOOTER //
// ./@fantasmagames/slot/src/modules/popupmenus/betmenu/BetlevelMenuEvents.ts